// Declared twice so that docs appear when selecting colors
export interface AmPalette extends Record<string, string> {
  /** **#F9E3EE** Pink */
  readonly am10: string;
  /** **#F8CCE0** Pink */
  readonly am30: string;
  /** **#F6A1C5** Pink */
  readonly am60: string;
  /** **#DF6CA0** Pink */
  readonly amPrimary: string;
  /** **#C82B72** Pink */
  readonly am80: string;
  /** **#8B1248** Pink */
  readonly am90: string;
}

export const amPalette: AmPalette = {
  am10: '#F9E3EE',
  am30: '#F8CCE0',
  am60: '#F6A1C5',
  amPrimary: '#DF6CA0',
  am80: '#C82B72',
  am90: '#8B1248',
};
